/** Number of growth-stage segments shown on the next-lesson word rows (GL 0–6). */
export const GROWTH_STAGE_COUNT = 6;

export type GrowthStageStatus = {
  labelId: 'new_word' | 'learning' | 'almost_there';
  isNew: boolean;
  filledStages: number;
};

/**
 * Maps a learnable's `growthLevel` (0–6+) onto the six-segment progress UI
 * used by the next-lesson card. Growth level 6 fills the bar completely.
 * Status thresholds: 0 → New word, 1–2 → Learning, 3+ → Almost there.
 */
export const getGrowthStageStatus = (growthLevel: number): GrowthStageStatus => {
  const filledStages = Math.max(0, Math.min(growthLevel, GROWTH_STAGE_COUNT));

  if (filledStages === 0) {
    return { labelId: 'new_word', isNew: true, filledStages };
  }

  if (filledStages < 3) {
    return { labelId: 'learning', isNew: false, filledStages };
  }

  return { labelId: 'almost_there', isNew: false, filledStages };
};
